import React from "react";
import { useStaticQuery, graphql } from "gatsby";
import { GatsbyImage, getImage } from "gatsby-plugin-image";

function trimCaption(caption) {
  if (caption && caption.split) {
    return caption.split("\n")[0];
  }
  return "Instagram linked photo";
}

export default function InstagramGallery({ children }) {
  const data = useStaticQuery(graphql`
    query {
      allInstagramContent(limit: 20, sort: { fields: timestamp, order: DESC }) {
        edges {
          node {
            id
            permalink
            caption
            localFile {
              childImageSharp {
                gatsbyImageData(
                  layout: FIXED
                  width: 200
                  height: 200
                  transformOptions: { cropFocus: CENTER }
                )
              }
            }
          }
        }
      }
    }
  `);

  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 md:flex md:flex-row md:flex-wrap md:overflow-y-hidden md:h-48">
      {data.allInstagramContent.edges.map((edge, index) => (
        <a
          key={edge.node.id}
          className={`group relative md:flex-grow h-48 md:h-full w-auto md:w-48 ${
            index >= 6 ? "hidden md:block" : "block"
          }`}
          href={edge.node.permalink}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={trimCaption(edge.node.caption)}
        >
          <GatsbyImage
            image={getImage(edge.node.localFile.childImageSharp)}
            style={{
              width: "100%",
              height: "100%",
            }}
            alt={trimCaption(edge.node.caption)}
          />
          <div className="absolute inset-x-0 inset-y-0 h-auto w-auto bg-gray-900 opacity-0 group-hover:opacity-40"></div>
        </a>
      ))}
    </div>
  );
}
